import {
    GET_SUB_MODULE_MASTER_SUCCESS,
    GET_SUB_MODULE_MASTER_FAILED,
    RESET_GET_SUB_MODULE_MASTER,
    LOADING_GET_SUB_MODULE_MASTER,
    NETWORK_ERROR_GET_SUB_MODULE_MASTER,
} from "../types";

const initialState = {
    isLoading: false,
    failed: false,
    success: false,
    data: {},
    networkError: "",
    invalidRequest: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GET_SUB_MODULE_MASTER: {
            return {
                ...state,
                isLoading: true,
                failed: false,
                success: false,
                invalidRequest: false,
                data: {},
            };
        }
        case GET_SUB_MODULE_MASTER_FAILED: {
            return {
                ...state,
                isLoading: false,
                failed: true,
                success: false,
                invalidRequest: false,
                data: action.payload,
            };
        }
        case GET_SUB_MODULE_MASTER_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                failed: false,
                success: true,
                invalidRequest: false,
                data: action.payload,
            };
        }
        case NETWORK_ERROR_GET_SUB_MODULE_MASTER: {
            return {
                ...state,
                isLoading: false,
                failed: true,
                success: false,
                invalidRequest: false,
                networkError: "Something went wrong. Check internet connection",
                data: {},
            };
        }
        case RESET_GET_SUB_MODULE_MASTER: {
            return (state = initialState);
        }

        default:
            return state;
    }
};
